export default __webpack_public_path__ + "static/media/2.03aa02e2.png";